import { PropsWithChildren, useMemo, useState } from "react";
import {
  SpotlightActionData,
  Spotlight,
} from "@mantine/spotlight";
import { IconSearch } from "@tabler/icons-react";

import { useDebouncedValue } from "@mantine/hooks";
import { router } from "@inertiajs/react";
import axios from "axios";
import { Group, Text, Badge } from "@mantine/core";

interface CustomSpotlightActionData extends Omit<SpotlightActionData, "type"> {
  onTrigger: () => void;
  status?: string;
  status_label?: string;
  cycle: {
    id: number;
    name: string;
  };
  type: string;
}

const CustomSpotlightProvider = ({ children }: PropsWithChildren) => {
  const [query, setQuery] = useState("");
  const [debouncedQuery] = useDebouncedValue(query, 300);
  const [results, setResults] = useState<CustomSpotlightActionData[]>([]);

  useMemo(() => {
    if (debouncedQuery) {
      axios
        .post(route("search"), {
          query: debouncedQuery,
        })
        .then((res) => {
          console.log(res.data);
          const data = Array.isArray(res.data) ? res.data : res.data.data;
          setResults(
            data.map(
              (hit: any) =>
                ({
                  id: hit.id.toString(),
                  label: hit.name,
                  description: hit.subject,
                  status: hit.status,
                  status_label: hit.status_label,
                  cycle: hit.cycle,
                  type: hit.typeLabel,
                  onTrigger: () => {
                    router.visit(
                      route("applications.show", {
                        cycle: hit.cycle.id,
                        application: hit.id,
                      })
                    );
                  },
                } as CustomSpotlightActionData)
            )
          );
        });
    }
  }, [debouncedQuery]);

  const items = results.map((item) => (
    <Spotlight.Action
      key={item.id}
      onClick={item.onTrigger}
    >
      <CustomAction {...item} />
    </Spotlight.Action>
  ));

  return (
    <>
      <Spotlight.Root
        query={query}
        onQueryChange={setQuery}
        shortcut={["mod + K", "/"]}
        closeOnClickOutside={true}
        closeOnEscape={true}
        closeOnActionTrigger={true}
      >
        <Spotlight.Search
          placeholder="Keresés..."
          leftSection={<IconSearch size="1.2rem" />}
        />
        <Spotlight.ActionsList>
          {debouncedQuery && items.length > 0 ? (
            items
          ) : (
            <Spotlight.Empty>Nincs találat...</Spotlight.Empty>
          )}
        </Spotlight.ActionsList>
      </Spotlight.Root>
      {children}
    </>
  );
};

function CustomAction(action: CustomSpotlightActionData) {
  return (
    <Group wrap="nowrap">
      <div style={{ flex: 1 }}>
        <div className={"flex flex-col"}>
          <Text className={"mr-3"}>{action.label}</Text>
          <Text c={"dimmed"} size={"sm"}>
            {action.type} - {action.cycle.name}
          </Text>
        </div>

        {action.description && (
          <Text color="dimmed" size="xs">
            {action.description}
          </Text>
        )}
      </div>

      {action.status && (
        <Badge
          variant={"light"}
          color={
            action.status === "accepted"
              ? "green"
              : action.status === "pending"
              ? "gray"
              : "red"
          }
        >
          {action.status_label}
        </Badge>
      )}
    </Group>
  );
}

export default CustomSpotlightProvider;
